export const ADD_NODE    = 'ADD_NODE';
export const UPDATE_NODE = 'UPDATE_NODE';
export const REMOVE_NODE = 'REMOVE_NODE';
export const SORT_NODE = 'SORT_NODE';
export const SELECT_NODE = 'SELECT_NODE';
export const UNSELECT_NODES = 'UNSELECT_NODES';
export const CLEAR_NODES = 'CLEAR_NODES';
export const LOAD_NODES = 'LOAD_NODES';
export const UPDATE_IMAGE = 'UPDATE_IMAGE';
export const ADD_ATTACHMENT = 'ADD_ATTACHEMENT';
export const REMOVE_ATTACHMENT = 'REMOVE_ATTACHEMENT';
export const LOAD_HEADER = 'LOAD_HEADER';
export const UPDATE_HEADER = 'UPDATE_HEADER';

export function addNode(info) {
  return {
    type: ADD_NODE,
    info,
  };
}

export function updateNode(id, params) {
  return {
    type: UPDATE_NODE,
    id,
    params,
  };
}

export function removeNode(id) {
  return {
    type: REMOVE_NODE,
    id,
  };
}

export function sortNode(oldIndex, newIndex) {
  return {
    type: SORT_NODE,
    oldIndex,
    newIndex,
  };
}

export function selectNode(id, buttonId, title, className) {
  return {
    type: SELECT_NODE,
    id,
    buttonId,
    title,
    className,
  };
}

export function unselectNodes() {
  return {
    type: UNSELECT_NODES,
  };
}

export function clearNodes() {
  return {
    type: CLEAR_NODES,
  };
}

export function loadNodes(nodes) {
  return {
    type: LOAD_NODES,
    nodes,
  };
}

export function loadHeader(header) {
  return {
    type: LOAD_HEADER,
    header,
  };
}

export function updateImage(id, index, url, fileName) {
  return {
    type: UPDATE_IMAGE,
    payload: {
      id,
      index,
      url,
      fileName,
    },
  };
}

export function addAttachment(id, attachment) {
  return {
    type: ADD_ATTACHMENT,
    payload: {
      id,
      attachment,
    },
  };
}

export function removeAttachment(id, fileName) {
  return {
    type: REMOVE_ATTACHMENT,
    payload: {
      id,
      fileName,
    },
  };
}

export function updateHeader(params) {
  return {
    type: UPDATE_HEADER,
    payload:{ params },
  };
}



// WEBPACK FOOTER //
// ./src/actions/nodeList.js